var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgToggleVector = function SvgToggleVector(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 10,
    viewBox: "0 0 16 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.4519 9.10023L8.00716 3.79727L13.5624 9.10023C14.1208 9.63326 15.0228 9.63326 15.5812 9.10023C16.1396 8.5672 16.1396 7.70615 15.5812 7.17312L9.0094 0.899771C8.45101 0.366741 7.54899 0.366741 6.9906 0.899771L0.418793 7.17312C-0.139597 7.70615 -0.139597 8.5672 0.418793 9.10023C0.977181 9.61959 1.89351 9.63326 2.4519 9.10023Z",
    fill: "#353247"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgToggleVector);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "toggleVector.0d39f2a622d8df3e1c19757a11c0b824.svg";